import React from 'react';
import { PictoProps } from '../index';

export const Arrow = (props: PictoProps) => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0L7.4641 6H0.535898L4 0Z" fill="#060D2C" />
  </svg>
);
